/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morse code translator`)
};

const es_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traductor de código Morse`)
};

const de_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morsecode-Übersetzer`)
};

const nl_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morsecode-vertaler`)
};

const fr_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducteur de code Morse`)
};

const it_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduttore di codice Morse`)
};

const pt_br2_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de código Morse`)
};

const pt_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradutor de código Morse`)
};

const ja_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モールス信号翻訳ツール`)
};

const zh_home_seo_mc_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔斯电码翻译器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_mc_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_mc_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_mc_title", locale)
	if (locale === "en") return en_home_seo_mc_title(inputs)
	if (locale === "es") return es_home_seo_mc_title(inputs)
	if (locale === "de") return de_home_seo_mc_title(inputs)
	if (locale === "nl") return nl_home_seo_mc_title(inputs)
	if (locale === "fr") return fr_home_seo_mc_title(inputs)
	if (locale === "it") return it_home_seo_mc_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_mc_title(inputs)
	if (locale === "pt") return pt_home_seo_mc_title(inputs)
	if (locale === "ja") return ja_home_seo_mc_title(inputs)
	return zh_home_seo_mc_title(inputs)
};